import styled from "styled-components/macro";

export const Content = styled.form`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  font-size: 1.6rem;
`;
